import type { AnchorType } from '@/shared/generated'
import type { TFunction } from 'i18next'

import { getAnchorsTypesChoices } from '@/entities/anchor'

export const getAnchorTypeValues = (type: AnchorType, t: TFunction) =>
	getAnchorsTypesChoices(t).find((choice) => choice.value === type)
